import React, { useEffect, useRef } from "react";

// A small modal for the ticket actions (resolve, assign, appeal ...). Esc or the backdrop closes it.
const Dialog = ({ title, onClose, children, footer }) => {
    const box = useRef(null);
    useEffect(() => {
        const key = (e) => { if (e.key === "Escape") onClose(); };
        document.addEventListener("keydown", key);
        box.current?.querySelector("textarea, input, select, button")?.focus();
        return () => document.removeEventListener("keydown", key);
    }, [onClose]);
    return (
        <div className="tk-backdrop" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
            <div className="tk-dialog" role="dialog" aria-modal="true" aria-labelledby="tk-dialog-title" ref={box}>
                <div className="tk-dialog-head">
                    <h5 id="tk-dialog-title" className="mb-0">{title}</h5>
                    <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
                </div>
                <div className="tk-dialog-body">{children}</div>
                {footer ? <div className="tk-dialog-foot">{footer}</div> : null}
            </div>
        </div>
    );
};

export default Dialog;
